module.exports = __webpack_public_path__ + "img/techno-cloud-logo.983ad255.png";